"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecoaCaptureApi = void 0;
const getEcoaCaptures = (folderId, visitId, visitSeq, crfPageId, crfPageSeq) => ({
    method: "GET",
    url: `/ecoa/visits/${folderId}/${visitId}/${visitSeq}/${crfPageId}/${crfPageSeq}/captures`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const captureEcoaData = {
    method: "POST",
    url: "/ecoa/visit/capture",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const submitEcoaCaptures = (folderId, visitId, visitSeq, crfPageId, crfPageSeq) => ({
    method: "POST",
    url: `/ecoa/visits/${folderId}/${visitId}/${visitSeq}/${crfPageId}/${crfPageSeq}/submit`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const captureEcoaPrescreeningCaptures = studyId => ({
    method: "POST",
    url: `/studies/${studyId}/pre-subjects`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
exports.ecoaCaptureApi = { getEcoaCaptures, captureEcoaData, submitEcoaCaptures, captureEcoaPrescreeningCaptures };
//# sourceMappingURL=ecoaCapture.js.map